<template>
  <ReGister/>

</template>

<script>
import ReGister from "@/components/LoginRegister/RegisterPrestataire.vue";

export default {
  name: 'RegisterView',
  components: {
    ReGister,
  }
}
</script>

<style scoped>


</style>